import { SPHERE_IDS, TARGET, THRESH } from './spheres.js';
/**
 * авторский эвристический «индекс баланса»: round((mean/10) * (1 - min(sd/5,1)*0.45) * 100).
 * sd — генеральное стандартное отклонение по восьми значениям.
 * это не измерение нейрофизиологической когерентности и не прогноз дохода.
 */
export function balance(values) {
    const v = SPHERE_IDS.map((id) => {
        const n = values[id];
        if (typeof n !== 'number' || !Number.isFinite(n)) {
            throw new TypeError(`balance: value for ${id} is not a finite number`);
        }
        return n;
    });
    const mean = v.reduce((a, b) => a + b, 0) / v.length;
    const variance = v.reduce((a, b) => a + (b - mean) ** 2, 0) / v.length;
    const spread = Math.sqrt(variance);
    const coh = (mean / TARGET) * (1 - Math.min(spread / 5, 1) * 0.45);
    return Math.round(coh * 100);
}
/** сферы ниже ватерлинии, от самой просевшей к менее просевшей */
export function lowSpheres(values) {
    return SPHERE_IDS.filter((id) => (values[id] ?? 0) < THRESH).sort((a, b) => (values[a] ?? 0) - (values[b] ?? 0));
}
/** правило двух сфер: две и более сферы ниже порога — сигнал */
export function isAlarm(values) {
    return lowSpheres(values).length >= 2;
}
export function defaultValues() {
    return Object.fromEntries(SPHERE_IDS.map((id) => [id, 5]));
}
//# sourceMappingURL=balance.js.map